import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import classes from './Preview.module.css';

export default function Mobile(props) {
  const { url, height } = props;
  const classess = [
    classes.mwb_gallery_template_view,
    height === 0 ? classes.fixedHeight : '',
  ];

  return (
    <div className={classess.join(' ')}>
      <Container>
        <div className={classes.mwb_middle_content}>
          <div className={classes.mwb_left_phone}>
            <div className={classes.mwb_phone_overlay}>
              <div className={classes.mwb_topbar}>
                <div className={classes.mwb_camera} />
                <div className={classes.mwb_camera} />
                <div className={classes.mwb_speaker} />
              </div>
              <div className={classes.mwb_left_phone_inner}>
                <div className={classes.mwb_message_wraper}>
                  <div className={classes.cbb_message}>
                    <iframe
                      title="mobile"
                      className={classes.mobile_iframe}
                      src={url}
                      width="100%"
                      height="100%"
                      allowFullScreen=""
                      frameBorder="0"
                    />
                  </div>
                </div>
              </div>
              <div className={classes.mwb_footerbar}>
                <div className={classes.mwb_widget}>
                  <span />
                  <span />
                  <span />
                </div>
                <div className={classes.mwb_home} />
                <div className={classes.mwb_back} />
              </div>
            </div>
          </div>
        </div>

        <div className={classes.mobile_frame}>
          <div className={classes.mobile_frame_header}>
            <span className={classes.mobile_frame_speeker} />
          </div>
          <div className="mobile_iframe_set" />
        </div>
      </Container>
    </div>
  );
}

Mobile.propTypes = {
  url: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
